import { Pipe, PipeTransform } from '@angular/core';
import {iProductAvailabilitiesEntity} from "../model/ProductAvailabilityModel";

@Pipe({
  name: 'cityfilter',
  pure: true
})
export class cityFilterPipe implements PipeTransform {
  transform(items: iProductAvailabilitiesEntity[], filter: string) {
    return items.filter(item => {
      if (item.pointOfService.city && !item.pointOfService.isDeliveryOrigin) {
        return item.pointOfService.city.toLowerCase().indexOf(filter.toLowerCase()) !== -1
      }
    });
  }
}
